<q-comp-questionnaire-unavailable *ngIf="!questionnaireService.availableQuestionnaire; else available"></q-comp-questionnaire-unavailable>
<ng-template #available>


  <div class="container font-verdana ">
    <div *ngIf="(!noQuest || readOnly) && (!certificationEnded || answerModel.isTrainer)" class="row">
      <div class="col-sm-offset-1 col-sm-12 px-0 px-sm-4">
        <div class="page" id="{{identQuestionnaire}}page0">
          <div [ngClass]="{'mh85': !isElearning, 'mh60' :isElearning}">
            <div class="ribbonGroup">
              <div class="ribbon">
                <h1 class=" q-questionnaire-title">{{questionnaire.titre}}</h1>
              </div>
              <div class="ribbonShadow"></div>
            </div>
            <div class="row mx-0">
              <div class="col-sm-12  my-4 px-5">
                <p id="description" class="text-justify text-center"></p>
              </div>
            </div>
            <div class="row mx-0">
              <div class="text-center mx-auto my-2">

                <div *ngIf="distanceUnlockTime<=0" class="pulsebtn pulseStartEnd">
                  <div class="QuestBtnStartEnd" (click)="pagePlus(0,questionnaire.certification.isCertification)">{{'questionnaireStart' |trad }}</div>
                </div>
                <div *ngIf="distanceUnlockTime>0" class="d-flex ">
                  <div class="mr-2">Ce questionnaire sera accessible le :</div>
                  <div style="line-height: unset;" class="badge q-main pulsebtn pulseStartEnd" ><i class="mr-1 fa-regular fa-clock"></i> {{strUnlockTime}}</div>                 
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="row mx-0">
            <div class="text-center col-sm-12 mb-2">
              <div class="icon-bar" *ngIf="ModeQuestionnaire !== 'EL' && !(ModeQuestionnaire === 'trainer' && (answerModel.modelType === 'EXO' || answerModel.modelType === 'Validation'))">
                <a *ngIf="answerModel.facebookLink" href="{{answerModel.facebookLink}}" target="_blank" class="facebook"><i class="fab fa-facebook"></i></a>
                <a *ngIf="answerModel.twitterLink" href="{{answerModel.twitterLink}}" target="_blank" class="twitter"><i class="fab fa-x-twitter"></i></a>
                <a *ngIf="answerModel.googlePlusLink" href="{{answerModel.googlePlusLink}}" target="_blank" class="google"><i class="fab fa-google"></i></a>
                <a *ngIf="answerModel.linkedInLink" href="{{answerModel.linkedInLink}}" target="_blank" class="linkedin"><i class="fab fa-linkedin"></i></a>
                <a *ngIf="answerModel.viadeoLink" href="{{answerModel.viadeoLink}}" target="_blank" class="viadeo"><i class="fab fa-viadeo"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div class="page" id="{{identQuestionnaire}}page{{i+1}}" *ngFor="let page of questionnaire.pagination; let i = index; let ilast = last" #page>
          <div [ngClass]="{'mh85': !isElearning, 'mh60' :isElearning}">
            <div class="ribbonGroup">
              <div class="ribbon">
                <h1 class="q-questionnaire-title px-3 px-sm-0">{{questionnaire.titre}}</h1>
                <div class="row">
                  <div class="col-6">
                    <div id="textTimer" class="timer d-flex" #timerTxt>
                      <div *ngIf="distance >86400000">{{countDown.day}}:</div>
                      <div *ngIf="distance > 3600000"> {{countDown.hour}}:</div>
                      <div *ngIf="distance >60000">{{countDown.minute}}:</div>
                      <div *ngIf="distance > 0">{{countDown.second}}</div>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="numPage">{{currentPage}}/{{questionnaire.pagination.length}}</div>
                  </div>
                </div>

                <div *ngIf="questionnaire.certification.timed && !readOnly" class="row">
                  <div class="col-12 timerBar"></div>
                  <div id="timerBarFill" class="col-12 timerBarFill" #timerBar></div>
                </div>
              </div>
              <div class="ribbonShadow"></div>
            </div>
            <div class="row">
              <div *ngFor="let element of page.elements; let y = index; let odd = odd;" id="{{identQuestionnaire}}element{{i}}{{y}}" class="col-sm-12 px-3 px-sm-5" [ngClass]="{'oddElement':odd}">
                <br />
                <!-- Section Question -->
                <div id="{{identQuestionnaire}}question{{i}}{{y}}" *ngIf="element.type==='question'">
                  <div class="row px-3">
                    <input *ngIf="ModeQuestionnaire==='trainer' && !(element.optionType === 'SATISFACTION' || element.optionType === 'AVIS')" type="number" [(ngModel)]="element.point" min="0" max="{{element.maxPoint}}" class="mr-2">
                    <button *ngIf="element.hint" [ngClass]="odd?'hintButton hintButtonOdd':'hintButton'" (click)="showHint(y,element)"> <i class="far fa-lightbulb fa-lg shake"></i></button>
                    <div class="hintBox" id="{{identQuestionnaire}}correct{{y}}" [innerHTML]="element.hintCorrect"></div>
                    <div class="hintBox" id="{{identQuestionnaire}}wrong{{y}}">{{element.hintWrong}}</div>
                    <h5 class="q-question">{{element.text}}</h5>
                    <div class="col-sm-12 text-center"> <ng-container *ngTemplateOutlet="templateMedia;context:{pMedia:element}"></ng-container> </div>

                  </div>

                  <div [ngSwitch]="element.optionType" class="row no-gutters">

                    <ng-container *ngIf="element.optionType != 'MATCHING' && element.optionType != 'DOMINO'">
                      <div *ngFor="let answers of element.options; let w = index ; let first = first" [ngClass]="element.mediaOption?'col-md-6 px-1':'col-md-12 px-1'">

                        <!--YesNo-->
                        <ng-template [ngSwitchCase]="'YesNo'">

                          <div *ngIf="first" class="row">
                            <div class="col-6 col-sm-6">
                              <div class="float-right">
                                <input [disabled]="readOnly" [attr.checked]="element.options[0].answer? '' : null" (change)="onSelectionChange(element.options[0],element.options)" class="YesNo ouiBtn  float-sm-right" name="{{identQuestionnaire}}OuiNon{{element.idEl}}{{i}}{{y}}" type="radio" id="{{identQuestionnaire}}oui{{element.idEl}}{{w}}{{i}}{{y}}">
                                <label [ngClass]="{'isSuccess': element.options[0].isCorrectAnswer && readOnly,'isFaill': !element.options[0].isCorrectAnswer && readOnly}" for="{{identQuestionnaire}}oui{{element.idEl}}{{w}}{{i}}{{y}}">
                                  {{element.options[0].text}}
                                  <i class="fas q-fa-checkyes" [ngClass]="{'fa-check': !readOnly, 'fa-check q-c-success': element.options[0].isCorrectAnswer && readOnly,'fa-times q-c-danger': !element.options[0].isCorrectAnswer && readOnly}"></i>
                                </label>
                              </div>
                            </div>
                            <div class="col-6 col-sm-6">
                              <div>
                                <input [disabled]="readOnly" [attr.checked]="element.options[1].answer? '' : null" (change)="onSelectionChange(element.options[1],element.options)" class="YesNo nonBtn" name="{{identQuestionnaire}}OuiNon{{element.idEl}}{{i}}{{y}}" type="radio" id="{{identQuestionnaire}}non{{element.idEl}}{{w}}{{i}}{{y}}">
                                <label [ngClass]="{'isSuccess': element.options[1].isCorrectAnswer && readOnly,'isFaill': !element.options[1].isCorrectAnswer && readOnly}" for="{{identQuestionnaire}}non{{element.idEl}}{{w}}{{i}}{{y}}">
                                  {{element.options[1].text}}
                                  <i class="fas q-fa-checkno" [ngClass]="{'fa-check': !readOnly, 'fa-check q-c-success': element.options[1].isCorrectAnswer && readOnly,'fa-times q-c-danger': !element.options[1].isCorrectAnswer && readOnly}"></i>
                                </label>
                              </div>
                            </div>
                          </div>
                        </ng-template>

                        <!--RADIO-->
                        <ng-template [ngSwitchCase]="'RADIOLISTENOTEQUESTION'">
                          <ng-container *ngIf="!element.mediaOption; else RadioMedia">
                            <div class="mx-1 mx-sm-4 my-1 inputGroup inputRound">
                              <input [disabled]="readOnly" type="radio" [attr.checked]="answers.answer? '' : null" (change)="onSelectionChange(answers,element.options)" name="{{identQuestionnaire}}radio{{element.idEl}}{{i}}{{y}}" id="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.isCorrectAnswer && readOnly, 'isFail': !answers.isCorrectAnswer && answers.answer && readOnly,'IsGoodAnswer':  answers.isCorrectAnswer && !answers.answer && readOnly,'IsBadAnswer': !answers.isCorrectAnswer && !answers.answer && readOnly}" for="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}">{{answers.text}}</label>
                            </div>
                          </ng-container>

                          <ng-template #RadioMedia>
                            <div class="my-1 inputGroup inputRound questMediaImg">
                              <input [disabled]="readOnly" type="radio" [attr.checked]="answers.answer? '' : null" (change)="onSelectionChange(answers,element.options)" name="{{identQuestionnaire}}radio{{element.idEl}}{{i}}{{y}}" id="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.isCorrectAnswer && readOnly, 'isFail': !answers.isCorrectAnswer && answers.answer && readOnly,'IsGoodAnswer':  answers.isCorrectAnswer && !answers.answer && readOnly,'IsBadAnswer': !answers.isCorrectAnswer && !answers.answer && readOnly}" for="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}">
                                <div class="inputContentImg">
                                  <div><ng-container *ngTemplateOutlet="templateMedia;context:{pMedia:answers}"></ng-container></div>
                                  <a class="row justify-content-center">{{answers.text}}</a>
                                </div>
                              </label>
                            </div>
                          </ng-template>

                        </ng-template>

                        <!--RADIO PONDERE-->
                        <ng-template [ngSwitchCase]="'RADIOLISTE'">
                          <ng-container *ngIf="!element.mediaOption; else RadioPondereMedia">
                            <div class="mx-1 mx-sm-4 my-1 inputGroup inputRound">
                              <input [disabled]="readOnly" type="radio" [attr.checked]="answers.answer? '' : null" (change)="onSelectionChange(answers,element.options)" name="{{identQuestionnaire}}radio{{element.idEl}}{{i}}{{y}}" id="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.point > 0 && readOnly,'isFail': answers.point < 0 && readOnly,'IsGoodAnswer':  answers.point > 0 && !answers.answer && readOnly,'IsBadAnswer':  answers.point <= 0 && !answers.answer && readOnly  }" for="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}">{{answers.text}}</label>
                            </div>
                          </ng-container>

                          <ng-template #RadioPondereMedia>
                            <div class="my-1 inputGroup inputRound questMediaImg">
                              <input [disabled]="readOnly" type="radio" [attr.checked]="answers.answer? '' : null" (change)="onSelectionChange(answers,element.options)" name="{{identQuestionnaire}}radio{{element.idEl}}{{i}}{{y}}" id="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.isCorrectAnswer && readOnly, 'isFail': !answers.isCorrectAnswer && answers.answer && readOnly,'IsGoodAnswer': answers.isCorrectAnswer && !answers.answer && readOnly,'IsBadAnswer': !answers.isCorrectAnswer && !answers.answer && readOnly }" for="{{identQuestionnaire}}radio{{element.idEl}}{{w}}{{i}}{{y}}">
                                <div class="inputContentImg">
                                  <div><ng-container *ngTemplateOutlet="templateMedia;context:{pMedia:answers}"></ng-container></div>
                                  <a class="row justify-content-center">{{answers.text}}</a>
                                </div>
                              </label>
                            </div>
                          </ng-template>

                        </ng-template>

                        <!--CHECKBOX LIST-->
                        <ng-template [ngSwitchCase]="'CHECKLISTENOTEQUESTION'">
                          <ng-container *ngIf="!element.mediaOption; else CheckMedia">
                            <div class="mx-1 mx-sm-4 my-1 inputGroup">
                              <input [disabled]="readOnly" type="checkbox" [attr.checked]="answers.answer" [(ngModel)]="answers.answer" value="check{{element.idEl}}" name="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" id="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.isCorrectAnswer && readOnly, 'isFail': !answers.isCorrectAnswer && answers.answer && readOnly,'IsGoodAnswer': answers.isCorrectAnswer && !answers.answer && readOnly,'IsBadAnswer': !answers.isCorrectAnswer && !answers.answer && readOnly}" for="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}">{{answers.text}}</label>
                            </div>
                          </ng-container>

                          <ng-template #CheckMedia>
                            <div class="my-1 inputGroup questMediaImg">
                              <input [disabled]="readOnly" type="checkbox" [attr.checked]="answers.answer" [(ngModel)]="answers.answer" value="check{{element.idEl}}" name="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" id="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.isCorrectAnswer && readOnly, 'isFail': !answers.isCorrectAnswer && answers.answer && readOnly,'IsGoodAnswer': answers.isCorrectAnswer && !answers.answer && readOnly,'IsBadAnswer': !answers.isCorrectAnswer && !answers.answer && readOnly}" for="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}">
                                <div class="inputContentImg">
                                  <div><ng-container *ngTemplateOutlet="templateMedia;context:{pMedia:answers}"></ng-container></div>
                                  <a class="row justify-content-center">{{answers.text}}</a>
                                </div>
                              </label>
                            </div>
                          </ng-template>
                        </ng-template>

                        <!--CHECKBOX LIST PONDERE-->
                        <ng-template [ngSwitchCase]="'CHECKLISTE'">
                          <ng-container *ngIf="!element.mediaOption; else CheckMediaPondere">
                            <div class="mx-1 mx-sm-4 my-1 inputGroup">
                              <input [disabled]="readOnly" type="checkbox" [attr.checked]="answers.answer" [(ngModel)]="answers.answer" value="check{{element.idEl}}" name="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" id="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.point > 0 && readOnly,'isFail': answers.point < 0 && readOnly,'IsGoodAnswer':  answers.point > 0 && !answers.answer && readOnly,'IsBadAnswer':  answers.point <= 0 && !answers.answer && readOnly }" for="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}">{{answers.text}}</label>
                            </div>
                          </ng-container>


                          <ng-template #CheckMediaPondere>
                            <div class="my-1 inputGroup questMediaImg">
                              <input [disabled]="readOnly" type="checkbox" [attr.checked]="answers.answer" [(ngModel)]="answers.answer" value="check{{element.idEl}}" name="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" id="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}" />
                              <label [ngClass]="{'isSuccess': answers.isCorrectAnswer && readOnly, 'isFail': !answers.isCorrectAnswer && answers.answer && readOnly,'IsGoodAnswer':  answers.point > 0 && !answers.answer && readOnly,'IsBadAnswer':  answers.point <= 0 && !answers.answer && readOnly}" for="{{identQuestionnaire}}check{{element.idEl}}{{w}}{{i}}{{y}}">
                                <div class="inputContentImg">
                                  <div><ng-container *ngTemplateOutlet="templateMedia;context:{pMedia:answers}"></ng-container></div>
                                  <a class="row justify-content-center">{{answers.text}}</a>
                                </div>
                              </label>
                            </div>
                          </ng-template>
                        </ng-template>

                        <!--TEXTAREA-->
                        <ng-template [ngSwitchCase]="'TEXTBOX'">
                          <label>
                            {{answers.text}}
                          </label>
                          <div style="float:left;width:100%;">
                            <textarea [disabled]="readOnly" [(ngModel)]="answers.answer" class="q-textarea" rows="5"></textarea>
                          </div>

                        </ng-template>

                        <!--AVIS-->
                        <ng-template [ngSwitchCase]="'AVIS'">
                          <label>
                            {{answers.text}}
                          </label>
                          <div style="float:left;width:100%;">
                            <textarea [disabled]="readOnly" [(ngModel)]="answers.answer" class="q-textarea" rows="5"></textarea>
                          </div>
                        </ng-template>

                        <!--SATISFACTION-->
                        <ng-template [ngSwitchCase]="'SATISFACTION'">
                          <label>
                            {{answers.text}}
                          </label>
                          <div class="row">
                            <div class="star-rating pl-5">
                              <div class="star-rating__wrap">
                                <input [disabled]="readOnly" class="star-rating__input" id="{{identQuestionnaire}}star-rating-5{{element.idEl}}{{w}}{{i}}{{y}}" type="radio" name="{{identQuestionnaire}}rating{{element.idEl}}{{w}}{{i}}{{y}}" value="5" [(ngModel)]="answers.answer">
                                <label class="star-rating__ico far fa-star fa-2x" for="{{identQuestionnaire}}star-rating-5{{element.idEl}}{{w}}{{i}}{{y}}" title="5"></label>
                                <input [disabled]="readOnly" class="star-rating__input" id="{{identQuestionnaire}}star-rating-4{{element.idEl}}{{w}}{{i}}{{y}}" type="radio" name="{{identQuestionnaire}}rating{{element.idEl}}{{w}}{{i}}{{y}}" value="4" [(ngModel)]="answers.answer">
                                <label class="star-rating__ico far fa-star fa-2x" for="{{identQuestionnaire}}star-rating-4{{element.idEl}}{{w}}{{i}}{{y}}" title="4"></label>
                                <input [disabled]="readOnly" class="star-rating__input" id="{{identQuestionnaire}}star-rating-3{{element.idEl}}{{w}}{{i}}{{y}}" type="radio" name="{{identQuestionnaire}}rating{{element.idEl}}{{w}}{{i}}{{y}}" value="3" [(ngModel)]="answers.answer">
                                <label class="star-rating__ico far fa-star fa-2x" for="{{identQuestionnaire}}star-rating-3{{element.idEl}}{{w}}{{i}}{{y}}" title="3"></label>
                                <input [disabled]="readOnly" class="star-rating__input" id="{{identQuestionnaire}}star-rating-2{{element.idEl}}{{w}}{{i}}{{y}}" type="radio" name="{{identQuestionnaire}}rating{{element.idEl}}{{w}}{{i}}{{y}}" value="2" [(ngModel)]="answers.answer">
                                <label class="star-rating__ico far fa-star fa-2x" for="{{identQuestionnaire}}star-rating-2{{element.idEl}}{{w}}{{i}}{{y}}" title="2"></label>
                                <input [disabled]="readOnly" class="star-rating__input" id="{{identQuestionnaire}}star-rating-1{{element.idEl}}{{w}}{{i}}{{y}}" type="radio" name="{{identQuestionnaire}}rating{{element.idEl}}{{w}}{{i}}{{y}}" value="1" [(ngModel)]="answers.answer">
                                <label class="star-rating__ico far fa-star fa-2x" for="{{identQuestionnaire}}star-rating-1{{element.idEl}}{{w}}{{i}}{{y}}" title="1"></label>
                              </div>
                            </div>
                          </div>
                        </ng-template>

                        <!--GAPFILL-->
                        <ng-template [ngSwitchCase]="'GAPFILL'">
                          <div class="row pl-5 pt-2 pb-2">
                            <ng-template ngFor let-i="index" let-word [ngForOf]="answers.text.split(' ')">

                              <div *ngIf="word.includes('[') && word.includes(']') && !readOnly">
                                <input class="gapWord" type="text" [(ngModel)]="answers.gapsFill[i].answer" />
                                <div class="gapBar"></div>
                              </div>

                              <div *ngIf="word.includes('[') && word.includes(']') && readOnly">
                                <input *ngIf="answers.gapsFill[i].isCorrect" class="gapWord gapCorrect" type="text" disabled [(ngModel)]="answers.gapsFill[i].answer" />
                                <input *ngIf="!answers.gapsFill[i].isCorrect" class="gapWord gapIncorrect" type="text" disabled [(ngModel)]="answers.gapsFill[i].answer" />
                              </div>

                              <a class="gapWord" *ngIf="!(word.includes('[') && word.includes(']'))">{{word}}</a>
                            </ng-template>
                          </div>



                          <div *ngIf="readOnly" class="row pl-5 mb-4">
                            <ng-template ngFor let-i="index" let-word [ngForOf]="answers.text.split(' ')">
                              <a class="gapWord" [ngClass]="{'q-c-success':answers.gapsFill[i].isCorrect ,'q-c-danger':!answers.gapsFill[i].isCorrect}" *ngIf="word.includes('[') && word.includes(']')">{{answers.gapsFill[i].text}}</a>
                              <a class="gapWord" *ngIf="!(word.includes('[') && word.includes(']'))">{{word}}</a>
                            </ng-template>
                          </div>

                        </ng-template>

                      </div>
                    </ng-container>
                    <!--MATCHING-->
                    <!--MATCHINGNOTEREPONSE-->
                    <ng-container *ngIf="element.optionType == 'MATCHING' || element.optionType == 'MATCHINGNOTEREPONSE'">
                      <div [ngClass]="readOnly ? 'col-md-6 px-1':'col-md-12 px-1'">
                        <div *ngIf="readOnly" class="text-center">Correction</div>
                        <Matching-Question id="{{identQuestionnaire}}radio{{element.idEl}}{{i}}{{y}}" [Mode]="readOnly ? ModeQuestion.rDiplay: ModeQuestion.reply" [QuestElement]="element" [PageId]="i+1" #matching></Matching-Question>
                      </div>
                      <div *ngIf="readOnly" class="col-md-6 px-1">
                        <div class="text-center">Réponse</div>
                        <Matching-Question id="{{identQuestionnaire}}radio{{element.idEl}}{{i}}{{y}}c" [Mode]="ModeQuestion.cDiplay" [QuestElement]="element" [PageId]="i+1" #matching></Matching-Question>
                      </div>
                    </ng-container>

                    <!--DOMINO-->
                    <ng-container *ngIf="element.optionType == 'DOMINO'">
                      <div class="col-md-12 px-1">
                        <Domino-Question id="{{identQuestionnaire}}domino{{element.idEl}}{{i}}{{y}}" [Mode]="readOnly ? ModeQuestion.rDiplay: ModeQuestion.reply" [QuestElement]="element" [PageId]="i+1" [Odd]="odd"></Domino-Question>
                      </div>
                    </ng-container>

                  </div>
                  <div *ngIf="element.commentaireTxt && readOnly" class="q-c-light-black mx-1 mx-sm-4 mt-2 px-1" [innerHTML]="element.commentaireTxt"></div>
                </div>
                <!-- Section Text -->
                <div *ngIf="element.type==='text'">
                  <h4 class="q-question">{{element.text}}</h4>
                  <ng-container *ngTemplateOutlet="templateMedia;context:{pMedia:element}"></ng-container>
                </div>
              </div>
              <div *ngIf="ilast">{{showFirstPage()}}</div>
            </div>
          </div>
          <br />
          <div class="row" *ngIf="showFooter">
            <div class="col-6 offset-sm-4 col-sm-2">
              <div *ngIf="!questionnaire.certification.isCertification || readOnly" class="QuestBtn previousBtn " (click)="pageMoins(i+1)">
                <i class="fas fa-caret-left q-fa-caretleft"></i>
                {{'backMAJ' | trad }}
              </div>
            </div>
            <div class="col-6 col-sm-2 ">
              <div class='QuestBtn nextBtn' *ngIf="i+1!=questionnaire.pagination.length " (click)="pagePlus(i+1,questionnaire.certification.isCertification,page)">
                {{'next' | trad }}
                <i class="fas fa-caret-right q-fa-caretright"></i>
              </div>
              <div class='QuestBtn validBtn' *ngIf="i+1==questionnaire.pagination.length && !readOnly &&  ModeQuestionnaire !='trainer' &&  ModeQuestionnaire !='ExoFromAdminEL'" (click)="finish(i+1,page)">
                <i class="fas fa-check q-fa-validquest"></i>
                {{'finishMAJ' | trad }}
              </div>
              <div class='QuestBtn validBtn' *ngIf="i+1==questionnaire.pagination.length && ModeQuestionnaire==='trainer' && answerModel.modelType !== 'EXO' && answerModel.modelType !== 'Validation'" (click)="correct()">
                <i class="fas fa-check q-fa-validquest"></i>
                {{'validate' | trad }}
              </div>
              <div class='QuestBtn validBtn' *ngIf="i+1==questionnaire.pagination.length && readOnly && ModeQuestionnaire!='trainer' && answerModel.modelType !== 'EXO' && answerModel.modelType !== 'Validation'" (click)="finQuestionnaire()">
                <i class="fas fa-check q-fa-validquest"></i>
                {{'finish' | trad }}
              </div>
              <div class='QuestBtn validBtn' *ngIf="ModeQuestionnaire ==='ExoFromAdminEL'">
                <i class="fas fa-check q-fa-validquest"></i>
                {{'finish' | trad }}
              </div>
            </div>
          </div>
        </div>




        <div class="page" id="{{identQuestionnaire}}pageFin">
          <div [ngClass]="{'mh85': !isElearning, 'mh60' :isElearning}">
            <div class="ribbonGroup">
              <div class="ribbon">
                <h1 class="q-questionnaire-title">{{questionnaire.titre}}</h1>
              </div>
              <div class="ribbonShadow"></div>
            </div>
            <div class="row">
              <div class="col-sm-12  my-4 px-5">
                <p id="messageFin" *ngIf="questionnaire.messageFin" class="text-justify text-center" [innerHTML]="questionnaire.messageFin"></p>
                <p *ngIf="!questionnaire.messageFin" class="text-justify text-center">{{'questionnaireThanks' | trad }}</p>
              </div>
            </div>
            <div class="row">
              <div class="text-center mx-auto my-2">

                <div *ngIf="!isEmail" class="pulsebtn pulseStartEnd">
                  <div class="QuestBtnStartEnd" (click)="finQuestionnaire()">{{'questionnaireValidate' | trad}}</div>
                </div>

                <div class="footertxt" *ngIf="isEmail">Votre questionnaire a bien été enregistré, vous pouvez fermer cette fenêtre</div>


              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="text-center col-sm-12 mb-2">
              <div class="icon-bar" *ngIf="ModeQuestionnaire !== 'EL'">
                <a *ngIf="answerModel.facebookLink" href="{{answerModel.facebookLink}}" target="_blank" class="facebook"><i class="fab fa-facebook"></i></a>
                <a *ngIf="answerModel.twitterLink" href="{{answerModel.twitterLink}}" target="_blank" class="twitter"><i class="fab fa-x-twitter"></i></a>
                <a *ngIf="answerModel.googlePlusLink" href="{{answerModel.googlePlusLink}}" target="_blank" class="google"><i class="fab fa-google"></i></a>
                <a *ngIf="answerModel.linkedInLink" href="{{answerModel.linkedInLink}}" target="_blank" class="linkedin"><i class="fab fa-linkedin"></i></a>
                <a *ngIf="answerModel.viadeoLink" href="{{answerModel.viadeoLink}}" target="_blank" class="viadeo"><i class="fab fa-viadeo"></i></a>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>


    <div class="row" *ngIf="noQuest && !readOnly && !certificationEnded">
      <div class="col-12 noData q-c-main">
        <p class="my-2"><i class="fas fa-exclamation-triangle fa-2x"></i></p>
        <div class="noDataTxt">
          Aucun questionnaire n'est rattaché à la propriété {{answerModel.modelType}},<br /> Veuillez contacter votre organisme pour plus d'informations
        </div>
      </div>
    </div>

    <div *ngIf="certificationEnded && !answerModel.isTrainer">
      <div class="row">
        <div class="col-12 noData q-c-main">
          <p class="my-2"><i class="fas fa-exclamation-triangle fa-2x"></i></p>
          <div class="noDataTxt">
            La certification est terminée
          </div>
        </div>
      </div>
      <div class="row justify-content-center" *ngIf="answerModel.modeQuestionnaire === 'EL' && answerModel.modelType === 'Validation'">
        <button type="button" class="btn btn-outline-success btn-lg mt-3" (click)="validModuleELAfterCertif()"><span> Terminer le module</span></button>
      </div>
    </div>



  </div>

  <div class="mediaZoomIn" *ngIf="mediaZoomIn"
       [@inOutAnimation]="{value: ':enter', params:{zoomPosStartX : zoomPosStartX, zoomPosStartY : zoomPosStartY, zoomPosEnd:zoomPosEnd }}"
       (@inOutAnimation.done)="inOutAnimationDoneEvent($event)"
       #MediaZoomIn>


    <img class="questMediaZoom" src="{{mediaZoomInPath}}" #MediaZoomInImage />
    <i (click)="closeMediaZoomIn()" class="fas fa-search-minus mediaZoomOutBtn"></i>
  </div>

  <!-- #region Element Media -->
  <ng-template #templateMedia let-media="pMedia">
    <ng-container [ngSwitch]="media.mediaType">
      <div class="row justify-content-center no-gutters position-relative mediaWrapper ">
        <ng-template [ngSwitchCase]="'VIDEO'">
          <video class="questMedia" src="{{media.mediaPath}}" controls></video>
        </ng-template>
        <ng-template [ngSwitchCase]="'IMG'">
          <img class="questMedia" src="{{media.mediaPath}}" />
          <div class="mediaZoomInBtn" (click)="mediaImgZoomIn($event,media.mediaPath)"><i class="fas fa-search-plus pe-none user-select-none"></i></div>
        </ng-template>
        <ng-template [ngSwitchCase]="'AUDIO'">
          <audio class="questMedia" src="{{media.mediaPath}}" controls></audio>
        </ng-template>
      </div>
    </ng-container>
  </ng-template>
  <!-- #endregion -->
</ng-template>
